import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import "./../../User/Styles/Addmachine.css";
export default function Addmachine() {
  const navigate = useNavigate();

  const [editData, setEditData] = useState(null);
  const [errors, setErrors] = useState({
    phone: "",
    image: "",
  });
  const [machines, setMachines] = useState([]);

  const [viewData, setViewData] = useState(null);
  const [paymentImage, setPaymentImage] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [renewMachineId, setRenewMachineId] = useState("");
  const [renewPopup, setRenewPopup] = useState(false);

  const [submitMode, setSubmitMode] = useState("");
  const [freePlanUserUsed, setFreePlanUserUsed] = useState(false);
  const [carouselOpen, setCarouselOpen] = useState(false);
  const [carouselImages, setCarouselImages] = useState([]);

  const [paymentMode, setPaymentMode] = useState(""); // "pending" | "renew"
  const [loading, setLoading] = useState(false);
  const [paying, setPaying] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const openCarousel = (images, index = 0) => {
    setCarouselImages(images);
    setCurrentImageIndex(index);
    setCarouselOpen(true);
  };

  const nextSlide = () => {
    setCurrentImageIndex((prev) => (prev + 1) % carouselImages.length);
  };

  const prevSlide = () => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + carouselImages.length) % carouselImages.length,
    );
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!carouselOpen) return;

      if (e.key === "ArrowRight") nextSlide();
      if (e.key === "ArrowLeft") prevSlide();
      if (e.key === "Escape") setCarouselOpen(false);
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  });
  const [renewData, setRenewData] = useState({
    ads_plan_id: "",
    show_ads_days: "",
    ads_amount: "",
    payment_screenshot: null,
  });
  const [form, setForm] = useState({
    id: "",
    machine_name: "",
    Area: "",
    NoOfHeads: "",
    NoOfNeedls: "",
    beamBody: "",
    Maxsewingspeed: "",
    usbport: "",
    motor: "",
    brand: "",
    model: "",
    condition: "",
    price: "",
    location: "",
    city: "",
    state: "",
    name: "",
    phone: "",
    description: "",
    image: [],
    left_head_type: "",
    right_head_type: "",
    Comtype: "",
    show_ads_days: "",
    ads_amount: "",
    payment_screenshot: null,
    beamBodyWidth: "",
    beamBodyHeight: "",
    machine_old: "",
    machine_year: "",
    machine_month: "",
    ads_plan_id: "",
  });

  const deleteMachine = async (id) => {
    if (!window.confirm("Delete machine?")) return;

    try {
      const res = await fetch(`${API.DELETE_MACHINE}&id=${id}`);

      const data = await res.json();

      alert(data.message);

      fetchMachines();
    } catch (error) {
      console.log(error);
    }
  };
  const handleRenewChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "show_ads_days") {
      const selectedPlan = adsPlans.find((p) => String(p.id) === String(value));

      setRenewData((prev) => ({
        ...prev,
        ads_plan_id: selectedPlan?.id || "",
        show_ads_days: selectedPlan?.days || "",
        ads_amount: selectedPlan?.amount || "",
      }));

      return;
    }

    if (name === "payment_screenshot") {
      setRenewData((prev) => ({
        ...prev,
        payment_screenshot: files[0],
      }));
    }
  };
  const handleRenewSubmit = async () => {
    if (!renewData.show_ads_days) {
      alert("Please select ads plan");
      return;
    }

    const machine = machines.find(
      (m) => String(m.id) === String(renewMachineId),
    );

    if (
      Number(renewData.ads_amount) === 0 &&
      machine?.machine_free_plan_used === 1
    ) {
      alert("Free plan already used");
      return;
    }

    if (Number(renewData.ads_amount) === 0) {
      const fd = new FormData();

      fd.append("id", renewMachineId);
      fd.append("show_ads_days", renewData.show_ads_days);
      fd.append("ads_amount", renewData.ads_amount);

      const res = await fetch(API.UPDATE_MACHINE, {
        method: "POST",
        body: fd,
      });

      const data = await res.json();

      alert(data.message);

      fetchMachines();

      setRenewPopup(false);

      return;
    }

    if (paymentMode === "pending") {
      startMachinePayment(
        renewMachineId,
        renewData.ads_amount,
        renewData.show_ads_days,
        renewData.ads_plan_id,
      );
      return;
    }

    startRenewMachinePayment(
      renewMachineId,
      renewData.ads_amount,
      renewData.show_ads_days,
    );
  };
  const [oldImages, setOldImages] = useState([]);
  const totalImages = form.image.length + oldImages.length;
  useEffect(() => {
    if (editData) {
      const parts = (editData.beamBody || "")
        .toLowerCase()
        .split("x")
        .map((v) => v.trim());

      const w = parts[0] || "";
      const h = parts[1] || "";

      let year = "";
      let month = "";

      if (editData.machine_old) {
        const ageParts = editData.machine_old.split("/");

        if (ageParts[0]) {
          year = ageParts[0].replace("Years", "").trim();
        }

        if (ageParts[1]) {
          month = ageParts[1].replace("Months", "").trim();
        }
      }
      setForm({
        id: editData.id,
        machine_name: editData.machine_name || "",
        Area: editData.Area || "",
        NoOfHeads: editData.NoOfHeads || "",
        NoOfNeedls: editData.NoOfNeedls || "",
        beamBody: editData.beamBody || "",
        Maxsewingspeed: editData.Maxsewingspeed || "",
        usbport: editData.usbport || "",
        motor: editData.motor || "",
        brand: editData.brand || "",
        model: editData.model || "",

        price: editData.price || "",
        location: editData.location || "",
        name: editData.name || "",
        city: editData.city || "",
        state: editData.state || "",
        phone: editData.phone || "",
        description: editData.description || "",
        image: [],
        left_head_type: editData.left_head_type || "",
        right_head_type: editData.right_head_type || "",
        Comtype: editData.Comtype || "",
        show_ads_days: editData.show_ads_days || "",
        ads_amount: editData.ads_amount || "",
        machine_old: editData.machine_old || "",
        machine_year: year,
        machine_month: month,

        beamBodyWidth: w || "",
        beamBodyHeight: h || "",
      });

      if (editData.image) {
        setOldImages(editData.image.split(","));
      }
    }
  }, [editData]);
  const [adsPlans, setAdsPlans] = useState([]);
  useEffect(() => {
    fetch(`${API.GET_ADS_PLANS}&type=machine`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setAdsPlans(data.data);
        }
      });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    // ✅ Phone Validation
    if (name === "phone") {
      if (!/^[0-9]{0,10}$/.test(value)) return;

      setErrors((prev) => ({
        ...prev,
        phone: value.length < 10 ? "Phone must be 10 digits" : "",
      }));

      setForm({ ...form, [name]: value });
      return;
    }

    if (name === "show_ads_days") {
      const selectedPlan = adsPlans.find((p) => String(p.id) === String(value));

      if (!selectedPlan) return;

      const isFreePlan = Number(selectedPlan.amount) === 0;

      if (isFreePlan && freePlanUserUsed) {
        setForm({
          ...form,
          ads_plan_id: "",
          show_ads_days: "",
          ads_amount: "",
        });

        return;
      }

      setForm({
        ...form,
        ads_plan_id: selectedPlan.id,
        show_ads_days: selectedPlan.days,
        ads_amount: selectedPlan.amount,
      });

      return;
    }
    // Machine Age Combine
    if (name === "machine_year" || name === "machine_month") {
      const updated = {
        ...form,
        [name]: value,
      };

      const years = updated.machine_year ? `${updated.machine_year} Years` : "";

      const months = updated.machine_month
        ? `${updated.machine_month} Months`
        : "";

      updated.machine_old =
        years && months ? `${years} / ${months}` : years || months || "";

      setForm(updated);
      return;
    }
    if (name === "beamBodyWidth" || name === "beamBodyHeight") {
      const updated = {
        ...form,
        [name]: value,
      };

      const width = name === "beamBodyWidth" ? value : form.beamBodyWidth;

      const height = name === "beamBodyHeight" ? value : form.beamBodyHeight;

      updated.beamBody = width && height ? `${width} x ${height}` : "";

      setForm(updated);
      return;
    }
    // ✅ Payment Screenshot Upload
    if (name === "payment_screenshot") {
      setForm({
        ...form,
        payment_screenshot: files[0],
      });
      return;
    }

    // ✅ Machine Images Upload
    // ✅ Machine Images Upload
    if (type === "file") {
      const selectedFiles = Array.from(files);

      // ✅ Maximum 5 MB per image
      const maxFileSize = 5 * 1024 * 1024; // 5 MB

      const oversizedFile = selectedFiles.find(
        (file) => file.size > maxFileSize,
      );

      if (oversizedFile) {
        setErrors((prev) => ({
          ...prev,
          image: `"${oversizedFile.name}" is larger than 5 MB. Maximum file size is 5 MB.`,
        }));

        // Clear file input
        e.target.value = "";
        return;
      }

      // ✅ Maximum 6 images total
      const totalImages =
        form.image.length + oldImages.length + selectedFiles.length;

      if (totalImages > 6) {
        setErrors((prev) => ({
          ...prev,
          image: "Maximum 6 images allowed",
        }));

        e.target.value = "";
        return;
      }

      setForm({
        ...form,
        image: [...form.image, ...selectedFiles],
      });

      setErrors((prev) => ({
        ...prev,
        image: "",
      }));

      // Clear input so same file can be selected again
      e.target.value = "";

      return;
    }

    // ✅ Default input handler
    setForm({ ...form, [name]: value });
  };
  const removeNewImage = (index) => {
    const newImages = form.image.filter((_, i) => i !== index);

    setForm({ ...form, image: newImages });

    if (newImages.length + oldImages.length === 0) {
      setErrors((prev) => ({
        ...prev,
        image: "Minimum 1 image required",
      }));
    }
  };

  const removeOldImage = (index) => {
    const images = oldImages.filter((_, i) => i !== index);
    setOldImages(images);

    if (form.image.length + images.length === 0) {
      setErrors((prev) => ({
        ...prev,
        image: "Minimum 1 image required",
      }));
    }
  };
  const resetForm = () => {
    setEditData(null);

    setForm({
      id: "",
      machine_name: "",
      Area: "",
      NoOfHeads: "",
      NoOfNeedls: "",
      beamBody: "",
      Maxsewingspeed: "",
      usbport: "",
      motor: "",
      brand: "",
      model: "",
      condition: "",
      price: "",
      location: "",
      city: "",
      state: "",
      name: "",
      phone: "",
      description: "",
      image: [],
      left_head_type: "",
      right_head_type: "",
      Comtype: "",
      show_ads_days: "",
      ads_amount: "",
      payment_screenshot: null,
      beamBodyWidth: "",
      beamBodyHeight: "",
      machine_old: "",
      machine_year: "",
      machine_month: "",
    });

    setOldImages([]);

    setSubmitMode("");

    setErrors({
      phone: "",
      image: "",
    });
  };

  const clearEdit = () => {
    setEditData(null);

    setForm({
      id: "",
      machine_name: "",
      Area: "",
      NoOfHeads: "",
      NoOfNeedls: "",
      beamBody: "",
      Maxsewingspeed: "",
      usbport: "",
      motor: "",
      brand: "",
      model: "",
      condition: "",
      price: "",
      location: "",
      city: "",
      state: "",
      name: "",
      phone: "",
      description: "",
      image: [],
      left_head_type: "",
      right_head_type: "",
      Comtype: "",
      show_ads_days: "",
      ads_amount: "",
      payment_screenshot: null,
      beamBodyWidth: "",
      beamBodyHeight: "",
      machine_old: "",
      machine_year: "",
      machine_month: "",
    });

    setOldImages([]);

    setErrors({
      phone: "",
      image: "",
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.image.length + oldImages.length === 0) {
      setErrors((prev) => ({
        ...prev,
        image: "Minimum 1 image required",
      }));
      return;
    }

    if (errors.phone || errors.image) {
      alert("Please fix validation errors");
      return;
    }

    const years = Number(form.machine_year || 0);
    const months = Number(form.machine_month || 0);

    if (years === 0 && months === 0) {
      alert("Please enter the machine age.");
      return;
    }

    if (months > 11) {
      alert("Months must be between 0 and 11.");
      return;
    }

    if (loading) return;

    setLoading(true);

    const formData = new FormData();
    const user = JSON.parse(sessionStorage.getItem("user"));

    formData.append("user_id", user.id);
    formData.append("submit_mode", submitMode);

    Object.keys(form).forEach((key) => {
      if (key !== "image" && key !== "payment_screenshot") {
        formData.append(key, form[key]);
      }
    });

    if (form.payment_screenshot) {
      formData.append("payment_screenshot", form.payment_screenshot);
    }

    if (form.id) {
      formData.append("id", form.id);
      formData.append("oldImages", oldImages.join(","));
    }

    form.image.forEach((file) => {
      formData.append("image[]", file);
    });

    const url = form.id ? API.UPDATE_MACHINE : API.ADD_MACHINE;

    try {
      const res = await fetch(url, {
        method: "POST",
        body: formData,
      });

      console.log("STATUS:", res.status);

      const text = await res.text();
      console.log("SERVER RESPONSE:", text);

      const data = JSON.parse(text);

      if (!data.status) {
        alert(data.message);
        return;
      }

      alert(data.message);

      await fetchMachines();

      resetForm();

      navigate("/user/add-machine");
    } catch (err) {
      console.log("SUBMIT ERROR:", err);
      alert(err.message);
    } finally {
      setLoading(false);
      setPaying(false);
    }
  };
  const startMachinePayment = async (machineId, amount) => {
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));

      const fd = new FormData();

      fd.append("user_id", user.id);
      fd.append("machine_id", machineId);
      fd.append("ads_amount", amount);

      const res = await fetch(API.CREATE_MACHINE_ORDER, {
        method: "POST",
        body: fd,
      });

      const order = await res.json();

      if (!order.success) {
        alert(order.message);
        return;
      }

      const options = {
        key: order.key,

        amount: order.amount,

        currency: order.currency,

        order_id: order.order_id,

        name: "Embroidery Bazar",

        description: "Machine Advertisement",

        handler: async function (response) {
          const verify = await fetch(API.VERIFY_MACHINE_PAYMENT, {
            method: "POST",

            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,

              razorpay_payment_id: response.razorpay_payment_id,

              razorpay_signature: response.razorpay_signature,
            }),
          });

          const verifyResult = await verify.json();

          if (verifyResult.success) {
            alert("Payment Successful");

            fetchMachines();

            navigate("/user/add-machine");
          } else {
            alert(verifyResult.message);
          }
        },

        modal: {
          ondismiss() {
            alert("Payment cancelled.");

            fetchMachines();

            navigate("/user/add-machine");
          },
        },
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function () {
        alert("Payment Failed");

        fetchMachines();

        navigate("/user/add-machine");
      });

      rzp.open();
    } catch (err) {
      console.log(err);

      alert("Payment Error");
    }
  };
  useEffect(() => {
    fetchMachines();
  }, []);

  const startRenewMachinePayment = async (machineId, amount, show_ads_days) => {
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));

      const fd = new FormData();

      fd.append("user_id", user.id);
      fd.append("machine_id", machineId);
      fd.append("ads_amount", amount);
      fd.append("show_ads_days", show_ads_days);

      const res = await fetch(API.CREATE_MACHINE_RENEW_ORDER, {
        method: "POST",
        body: fd,
      });

      const order = await res.json();

      if (!order.success) {
        alert(order.message);
        return;
      }

      const options = {
        key: order.key,

        amount: order.amount,

        currency: order.currency,

        order_id: order.order_id,

        name: "Embroidery Bazar",

        description: "Machine Ads Renewal",

        handler: async function (response) {
          try {
            const verify = await fetch(API.VERIFY_MACHINE_RENEW_PAYMENT, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              }),
            });

            const verifyResult = await verify.json();

            if (verifyResult.success) {
              alert("Machine Ads Renewed Successfully");

              setRenewPopup(false);

              setRenewData({
                ads_plan_id: "",
                show_ads_days: "",
                ads_amount: "",
                payment_screenshot: null,
              });

              fetchMachines();

              navigate("/user/add-machine");
            } else {
              alert(verifyResult.message);
            }
          } catch (err) {
            console.log(err);
            alert("Payment Verification Failed");
          }
        },

        modal: {
          ondismiss: function () {
            alert("Payment Cancelled");

            fetchMachines();
          },
        },

        prefill: {
          name: user.name || "",
          email: user.email || "",
          contact: user.phone || "",
        },

        theme: {
          color: "#3399cc",
        },
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function (response) {
        alert(response.error.description || "Payment Failed");

        fetchMachines();
      });

      rzp.open();
    } catch (err) {
      console.log(err);
      alert("Unable to start payment.");
    }
  };
  const fetchMachines = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));

      const res = await fetch(
        `${API.LIST_MACHINES}&user_id=${user.id}&t=${Date.now()}`,
      );

      const data = await res.json();

      setMachines(Array.isArray(data) ? data : []);

      // check free plan usage
      if (Array.isArray(data)) {
        const used = data.some(
          (item) => Number(item.machine_free_plan_used) === 1,
        );

        setFreePlanUserUsed(used);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const isExpired = (item) => {
    // Pending machine should not show renew button
    if (item.status?.toLowerCase() === "pending") {
      return false;
    }

    // If no expiry date
    if (!item.ads_end_date) {
      return false;
    }

    const now = new Date().getTime();
    const expiry = new Date(item.ads_end_date.replace(" ", "T")).getTime();

    return expiry <= now;
  };
  const getTimeLeft = (expiryDate, status) => {
    // Don't show timer for PENDING machines
    if (status?.toLowerCase() === "pending") return null;

    if (!expiryDate) return null;

    const now = new Date().getTime();
    const expiry = new Date(expiryDate.replace(" ", "T")).getTime();
    const diff = expiry - now;

    if (diff <= 0) return "Expired";

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const mins = Math.floor((diff / (1000 * 60)) % 60);

    return `${days}d ${hours}h ${mins}m`;
  };
  const [imageIndexes, setImageIndexes] = useState({});
  const nextImage = (e, item, images) => {
    e.stopPropagation();

    const current = imageIndexes[item.id] || 0;

    if (current >= images.length - 1) {
      setImageIndexes((prev) => ({
        ...prev,
        [item.id]: 0, // Go back to the first image
      }));
      return;
    }

    setImageIndexes((prev) => ({
      ...prev,
      [item.id]: current + 1,
    }));
  };

  const prevImage = (e, item) => {
    e.stopPropagation();

    const current = imageIndexes[item.id] || 0;

    if (current === 0) return;

    setImageIndexes((prev) => ({
      ...prev,
      [item.id]: current - 1,
    }));
  };

  return (
    <div className="workspace-container">
      <h2 className="machine-title">
        {form.id ? "Edit Machine" : "Add Machine"}
      </h2>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
        className="workspace-form"
      >
        <div className="workspace-section">
          <label>Seller Details</label>
          <hr />
        </div>

        <div className="workspace-grid">
          <div className="row">
            <div className="col-md-6">
              <div className="workspace-field-small">
                <label>Seller Name</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Enter full name"
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="workspace-field-small">
                <label>Address</label>
                <input
                  name="location"
                  value={form.location}
                  onChange={handleChange}
                  placeholder="Enter full address"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="workspace-field-small">
                <label>Mobile No</label>
                <input
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="Enter phone number"
                  required
                />

                {errors.phone && <span className="error">{errors.phone}</span>}
              </div>
            </div>

            <div className="col-md-4">
              <div className="workspace-field-xsmall">
                <label>City</label>
                <input
                  name="city"
                  value={form.city}
                  onChange={handleChange}
                  placeholder="Enter city"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="workspace-field-xsmall">
                <label>State</label>
                <input
                  name="state"
                  value={form.state}
                  onChange={handleChange}
                  placeholder="Enter state"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="workspace-section">
          <label>Machine Details</label>
          <hr />
        </div>
        <div className="workspace-grid">
          <div className="row">
            <div className="col-md-8">
              {" "}
              <div className="workspace-field">
                <label>Machine Type</label>
                <select
                  name="machine_name"
                  value={form.machine_name}
                  onChange={handleChange}
                  required
                  className={form.machine_name ? "active" : ""}
                >
                  <option value="" disabled hidden>
                    Select Machine
                  </option>
                  <option value="Flat Embroidery Machine">
                    Flat Embroidery Machine
                  </option>
                  <option value="Sequin Embroidery Machine">
                    Sequin Embroidery Machine
                  </option>
                  <option value="Cording Embroidery Machine">
                    Cording Embroidery Machine
                  </option>
                  <option value="Chain Embroidery Machine">
                    Chain Embroidery Machine
                  </option>
                  <option value="Beads Embroidery Machine">
                    Beads Embroidery Machine
                  </option>

                  <option value="Sequin With Cording Embroidery Machine">
                    Sequin With Cording Embroidery Machine
                  </option>

                  <option value="Sequin With Beads Embroidery Machine">
                    Sequin With Beads Embroidery Machine
                  </option>
                  <option value="Sequin With Beads And Cording Embroidery Machine">
                    Sequin With Beads And Cording Embroidery Machine
                  </option>
                </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="workspace-field-xsmall">
                <label>Area (MM)</label>
                <input
                  name="Area"
                  value={form.Area}
                  onChange={handleChange}
                  placeholder="200"
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="workspace-field">
                <label>Left Side Head Type</label>
                <select
                  name="left_head_type"
                  value={form.left_head_type}
                  onChange={handleChange}
                  className={form.left_head_type ? "active" : ""}
                >
                  <option value="" disabled hidden>
                    Select Left Side Head Type
                  </option>

                  <option value="SINGLE SEQUIN DEVICE">
                    SINGLE SEQUIN DEVICE
                  </option>
                  <option value="DUAL SEQUIN DEVICE">DUAL SEQUIN DEVICE</option>
                  <option value="THREE SEQUIN DEVICE">
                    THREE SEQUIN DEVICE
                  </option>
                  <option value="FOUR SEQUIN DEVICE">FOUR SEQUIN DEVICE</option>
                  <option value="EIGHT SEQUIN DEVICE">
                    EIGHT SEQUIN DEVICE
                  </option>
                  <option value="TWELVE SEQUIN DEVIC">
                    TWELVE SEQUIN DEVICE
                  </option>
                  <option value="CORDING DEVICE">CORDING DEVICE</option>
                  <option value="SINGLE BEAD DEVICE">SINGLE BEAD DEVICE</option>
                  <option value="DUAL BEAD DEVICE">DUAL BEAD DEVICE</option>
                  <option value="DUAL BEAD WITH DUAL SEQUIN DEVICE">
                    DUAL BEAD WITH DUAL SEQUIN DEVICE
                  </option>
                  <option value="THREE BEAD DEVICE">THREE BEAD DEVICE</option>
                  <option value="THREE BEAD WITH DUAL SEQUIN DEVICE">
                    THREE BEAD WITH DUAL SEQUIN DEVICE
                  </option>
                  <option value="FOUR bEAD DEVICE">FOUR bEAD DEVICE</option>
                  <option value="FOUR BEAD WITH DUAL SEQUIN DEVICE">
                    FOUR BEAD WITH DUAL SEQUIN DEVICE
                  </option>
                  <option value="NONE">NONE</option>
                </select>
              </div>
            </div>
            <div className="col-md-6">
              {" "}
              <div className="workspace-field">
                <label>Right Side Head Type</label>
                <select
                  name="right_head_type"
                  value={form.right_head_type}
                  onChange={handleChange}
                  className={form.right_head_type ? "active" : ""}
                >
                  <option value="" disabled hidden>
                    Select Right Side Head Type
                  </option>
                  <option value="SINGLE SEQUIN DEVICE">
                    SINGLE SEQUIN DEVICE
                  </option>
                  <option value="DUAL SEQUIN DEVICE">DUAL SEQUIN DEVICE</option>
                  <option value="THREE SEQUIN DEVICE">
                    THREE SEQUIN DEVICE
                  </option>
                  <option value="FOUR SEQUIN DEVICE">FOUR SEQUIN DEVICE</option>
                  <option value="EIGHT SEQUIN DEVICE">
                    EIGHT SEQUIN DEVICE
                  </option>
                  <option value="TWELVE SEQUIN DEVIC">
                    TWELVE SEQUIN DEVICE
                  </option>
                  <option value="CORDING DEVICE">CORDING DEVICE</option>
                  <option value="SINGLE BEAD DEVICE">SINGLE BEAD DEVICE</option>
                  <option value="DUAL BEAD DEVICE">DUAL BEAD DEVICE</option>
                  <option value="DUAL BEAD WITH DUAL SEQUIN DEVICE">
                    DUAL BEAD WITH DUAL SEQUIN DEVICE
                  </option>
                  <option value="THREE BEAD DEVICE">THREE BEAD DEVICE</option>
                  <option value="THREE BEAD WITH DUAL SEQUIN DEVICE">
                    THREE BEAD WITH DUAL SEQUIN DEVICE
                  </option>
                  <option value="FOUR bEAD DEVICE">FOUR bEAD DEVICE</option>
                  <option value="FOUR BEAD WITH DUAL SEQUIN DEVICE">
                    FOUR BEAD WITH DUAL SEQUIN DEVICE
                  </option>
                  <option value="NONE">NONE</option>
                </select>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="workspace-field-xsmall">
                <label>Brand</label>
                <input
                  name="brand"
                  value={form.brand}
                  onChange={handleChange}
                  placeholder="ZSK"
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="workspace-field-xsmall">
                <label>Model</label>
                <input
                  name="model"
                  value={form.model}
                  onChange={handleChange}
                  placeholder="Model number"
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="workspace-field-small">
                <label>No Of Heads</label>
                <input
                  type="number"
                  name="NoOfHeads"
                  value={form.NoOfHeads}
                  onChange={handleChange}
                  placeholder="Example : 1"
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="workspace-field-small">
                <label>Max Sewing Speed (RPM)</label>
                <input
                  type="number"
                  name="Maxsewingspeed"
                  value={form.Maxsewingspeed}
                  onChange={handleChange}
                  placeholder="RPM"
                  required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="workspace-field-xsmall">
                <label>Motor</label>
                <input
                  name="motor"
                  value={form.motor}
                  onChange={handleChange}
                  placeholder="Servo / AC"
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="workspace-field-small">
                <label>Computer Type</label>
                <input
                  name="Comtype"
                  value={form.Comtype}
                  onChange={handleChange}
                  placeholder="Daho"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="workspace-field-small">
                <label>No Of Needles</label>
                <input
                  type="number"
                  name="NoOfNeedls"
                  value={form.NoOfNeedls}
                  onChange={handleChange}
                  placeholder="Example : 12"
                  required
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="usb-field">
                <label className="usb-title">USB Port</label>

                <div className="usb-radio-group">
                  <label className="usb-radio">
                    <input
                      type="radio"
                      name="usbport"
                      value="Yes"
                      checked={form.usbport === "Yes"}
                      onChange={handleChange}
                    />
                    Yes
                  </label>

                  <label className="usb-radio">
                    <input
                      type="radio"
                      name="usbport"
                      value="No"
                      checked={form.usbport === "No"}
                      onChange={handleChange}
                    />
                    No
                  </label>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="workspace-field-small">
                <label>Price(₹)</label>
                <input
                  type="number"
                  name="price"
                  value={form.price}
                  onChange={handleChange}
                  placeholder="Enter price in Rupees"
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              {" "}
              <div className="workspace-field-small">
                <label>Beam Body Size (MM)</label>

                <div className="double-input-group">
                  <input
                    type="number"
                    name="beamBodyWidth"
                    value={form.beamBodyWidth}
                    onChange={handleChange}
                    placeholder="Width"
                  />

                  <span className="double-input-separator">×</span>

                  <input
                    type="number"
                    name="beamBodyHeight"
                    value={form.beamBodyHeight}
                    onChange={handleChange}
                    placeholder="Height"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="workspace-field-small">
                <label>Machine Age</label>

                <div className="double-input-group">
                  <input
                    type="number"
                    name="machine_year"
                    value={form.machine_year || ""}
                    onChange={handleChange}
                    placeholder="Years"
                    min="0"
                  />

                  <input
                    type="number"
                    name="machine_month"
                    value={form.machine_month || ""}
                    onChange={handleChange}
                    placeholder="Months"
                    min="0"
                    max="11"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="workspace-field-3">
                <label>Description</label>
                <textarea
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  placeholder="Enter machine description"
                />
              </div>
            </div>
          </div>

          {oldImages.length > 0 && (
            <div className="machine-preview-images">
              {oldImages.map((img, index) => (
                <div className="machine-image-box" key={index}>
                  <img
                    src={`${UPLOADS.MACHINE_IMAGE}${editData.user_id}/${img}?t=${Date.now()}`}
                    alt="machine"
                  />
                  <button type="button" onClick={() => removeOldImage(index)}>
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
          <div className="workspace-field machine-full-width">
            <label>
              Image Upload (Max 6)
              {totalImages >= 6}
            </label>

            <input
              type="file"
              multiple
              onChange={handleChange}
              disabled={totalImages >= 6}
            />

            {errors.image && <span className="error">{errors.image}</span>}

            <div className="machine-preview-images">
              {form.image.map((img, index) => (
                <div className="machine-image-box" key={index}>
                  <img src={URL.createObjectURL(img)} alt="preview" />
                  <button type="button" onClick={() => removeNewImage(index)}>
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
          <small>{totalImages}/6 Images Selected</small>

          <div className="workspace-action-row">
            {form.id && (
              <button
                type="button"
                className="btn-cancel-edit"
                onClick={clearEdit}
              >
                <i className="bi bi-x-circle me-2"></i>
                Cancel Edit
              </button>
            )}
            <button
              type="submit"
              className="btn-submit-workspace"
              disabled={loading || paying}
            >
              {loading
                ? "Submitting..."
                : paying
                  ? "Opening Payment..."
                  : "Submit"}
            </button>
          </div>
        </div>
      </form>
      <div className="designs-grid">
        {machines.length > 0 ? (
          machines.map((item) => {
            const images = item.image
              ? item.image.split(",").filter((img) => img.trim() !== "")
              : [];

            return (
              <div className="design-card" key={item.id}>
                <div className="machine-img-container">
                  <img
                    src={`${UPLOADS.MACHINE_IMAGE}${item.user_id}/${
                      images[imageIndexes[item.id] || 0]
                    }?t=${Date.now()}`}
                    alt={item.machine_name}
                  />
                  {images.length > 1 && (
                    <>
                      {(imageIndexes[item.id] || 0) > 0 && (
                        <button
                          className="img-arrow left-arrow"
                          onClick={(e) => prevImage(e, item)}
                        >
                          <i className="bi bi-chevron-left"></i>
                        </button>
                      )}

                      <button
                        className="img-arrow right-arrow"
                        onClick={(e) => nextImage(e, item, images)}
                      >
                        <i className="bi bi-chevron-right"></i>
                      </button>
                    </>
                  )}

                  <span
                    className={`bm_cardStatus ${item.status.toLowerCase()}`}
                  >
                    {item.status}
                  </span>
                </div>

                <div className="machine-body">
                  <div className="machine-type">
                    <h4 className="machine-name">{item.machine_name}</h4>
                  </div>

                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <div className="price-block">
                      <span className="currency-symbol">₹</span>

                      <span className="amount">
                        {Number(item.price).toLocaleString("en-IN")}
                      </span>
                    </div>
                  </div>

                  <div className="spec-row mt-0 mb-0">
                    <div className="spec-item">
                      <span className="spec-label">Brand:</span>

                      <span className="spec-value">{item.brand}</span>
                    </div>

                    <div className="spec-item">
                      <span className="spec-label">Area:</span>

                      <span className="spec-value">{item.Area}</span>
                    </div>
                  </div>
                  <div className="spec-item mt-0 p-1">
                    <span className="spec-label1">
                      {" "}
                      <i className="bi bi-person-fill me-2"></i>
                      {item.name}
                    </span>
                  </div>
                  <div className="spec-item mt-1 mb-1">
                    <div className="location-info mb-0">
                      <i className="bi bi-geo-alt-fill"></i>
                      {item.city}, {item.state}
                    </div>
                  </div>

                  <div className="machine-actions mt-2">
                    <button
                      className="action-btn view-action"
                      onClick={() => setViewData(item)}
                      title="View"
                    >
                      <i className="bi bi-eye-fill"></i>
                    </button>
                    <button
                      className="action-btn edit-action"
                      onClick={() => setEditData(item)}
                    >
                      <i className="bi bi-pencil-square"></i>
                    </button>

                    <button
                      className="action-btn delete-action"
                      onClick={() => deleteMachine(item.id)}
                    >
                      <i className="bi bi-trash-fill"></i>
                    </button>
                  </div>

                  <div className="mt-2 mb-0 time">
                    {item.status?.toLowerCase() === "pending" ? (
                      Number(item.show_ads_days) > 0 ? (
                        // Ads plan already selected/request sent
                        <div
                          style={{
                            color: "#ff9800",
                            fontWeight: "bold",
                            fontSize: "12px",
                            textAlign: "center",
                            padding: "7px",
                          }}
                        >
                          <i className="bi bi-clock-history me-1"></i>
                          Request Sent
                        </div>
                      ) : (
                        // No Ads plan selected
                        <button
                          className="renew-btn"
                          onClick={() => {
                            setPaymentMode("pending");
                            setRenewMachineId(item.id);

                            setRenewData({
                              ads_plan_id: "",
                              show_ads_days: "",
                              ads_amount: "",
                              payment_screenshot: null,
                            });

                            setRenewPopup(true);
                          }}
                        >
                          <i className="bi bi-credit-card me-2"></i>
                          Select Ads
                        </button>
                      )
                    ) : !isExpired(item) ? (
                      item.ads_end_date && (
                        <div
                          style={{
                            color: "green",
                            fontWeight: "bold",
                            fontSize: "12px",
                            textAlign: "center",
                            padding: "7px",
                          }}
                        >
                          Time Left:{" "}
                          {getTimeLeft(item.ads_end_date, item.status)}
                        </div>
                      )
                    ) : (
                      <button
                        className="renew-btn"
                        onClick={() => {
                          setPaymentMode("renew");
                          setRenewMachineId(item.id);

                          setRenewData({
                            ads_plan_id: "",
                            show_ads_days: "",
                            ads_amount: "",
                            payment_screenshot: null,
                          });

                          setRenewPopup(true);
                        }}
                      >
                        <i className="bi bi-arrow-clockwise me-2"></i>
                        Renew Ads
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>No machines found.</p>
        )}
      </div>

      {viewData && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>⚙ Machine Details</h3>

              <button
                className="close-icon-btn"
                onClick={() => setViewData(null)}
              >
                ✕
              </button>
            </div>

            <div className="popup-grid">
              <div>
                <label>Machine Type</label>
                <p>{viewData.machine_name || "-"}</p>
              </div>
              <div>
                <label>Left Side Head Type</label>
                <p>{viewData.left_head_type || "-"}</p>
              </div>
              <div>
                <label>Right Side Head Type</label>
                <p>{viewData.right_head_type || "-"}</p>
              </div>
              <div>
                <label>Area</label>
                <p>{viewData.Area || "-"}</p>
              </div>
              <div>
                <label>Brand</label>
                <p>{viewData.brand || "-"}</p>
              </div>
              <div>
                <label>Model</label>
                <p>{viewData.model || "-"}</p>
              </div>
              <div>
                <label> No Of Heads</label>
                <p>{viewData.NoOfHeads || "-"}</p>
              </div>
              <div>
                <label>No Of Needles</label>
                <p>{viewData.NoOfNeedls || "-"}</p>
              </div>
              <div>
                <label>Max Sewing Speed</label>
                <p>{viewData.Maxsewingspeed || "-"} RPM</p>
              </div>
              <div>
                <label>Beam Body Size(MM)</label>
                <p>{viewData.beamBody || "-"}</p>
              </div>
              <div>
                <label>Computer Type</label>
                <p>{viewData.Comtype || "-"}</p>
              </div>

              <div>
                <label>Motor</label>
                <p>{viewData.motor || "-"}</p>
              </div>
              <div>
                <label>Usb Port</label>
                <p>{viewData.usbport || "-"}</p>
              </div>

              <div>
                <label>Machine Age</label>
                <p>{viewData.machine_old || "-"}</p>
              </div>
              <div>
                <label>Price</label>
                <p>₹ {Number(viewData.price).toLocaleString("en-IN")}</p>
              </div>
              <div>
                <label>Status</label>
                <p>{viewData.status || "-"}</p>
              </div>
              <div>
                <label>Address</label>
                <p>{viewData.location || "-"}</p>
              </div>
              <div>
                <label>City & State</label>
                <p>
                  {viewData.city || "-"} ,{viewData.state || "-"}
                </p>
              </div>
              <div>
                <label>Seller</label>
                <p>
                  {viewData.name || "-"} ({viewData.phone || "-"})
                </p>
              </div>

              <div>
                <label>Ads Duration</label>
                <p>{viewData.show_ads_days || "-"}</p>
              </div>

              <div>
                <label>Payed amount</label>
                <p>{viewData.ads_amount || "-"}</p>
              </div>
              {viewData.payment_screenshot && (
                <div className="payment-proof-section">
                  <label>Payment Screenshot</label>

                  <div
                    className="popup-images"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPaymentImage(
                        `${UPLOADS.MACHINE_IMAGE}${viewData.user_id}/payment/${viewData.payment_screenshot}`,
                      );
                      setShowPaymentModal(true);
                    }}
                  >
                    <img
                      src={`${UPLOADS.MACHINE_IMAGE}${viewData.user_id}/payment/${viewData.payment_screenshot}`}
                      alt="payment"
                      className="payment-thumb"
                    />
                  </div>
                </div>
              )}
            </div>
            {showPaymentModal && (
              <div
                className="image-modal-overlay"
                onClick={() => setShowPaymentModal(false)}
              >
                <div
                  className="image-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="image-close-btn"
                    onClick={() => setShowPaymentModal(false)}
                  >
                    ✖
                  </button>

                  <img
                    src={paymentImage}
                    alt="Payment Full"
                    className="full-payment-image"
                  />
                </div>
              </div>
            )}

            <div className="description-box">
              <label>Description</label>
              <p>{viewData.description || "-"}</p>
            </div>
            <div className="popup-images">
              <div className="popup-images">
                {viewData.image &&
                  viewData.image
                    .split(",")
                    .filter((img) => img.trim() !== "")
                    .map((img, i, arr) => {
                      const allImages = arr.map(
                        (image) =>
                          `${UPLOADS.MACHINE_IMAGE}${viewData.user_id}/${image}?t=${Date.now()}`,
                      );

                      return (
                        <img
                          key={i}
                          src={allImages[i]}
                          alt={`machine-${i}`}
                          style={{ cursor: "pointer" }}
                          onClick={() => openCarousel(allImages, i)}
                        />
                      );
                    })}
              </div>
            </div>
          </div>
        </div>
      )}
      {renewPopup && (
        <div className="popup-overlay">
          <div className="popup-box renew-popup">
            <div className="popup-header">
              <h3>{paymentMode === "pending" ? "Select Ads" : "Renew Ads"}</h3>

              <button
                className="close-icon-btn"
                onClick={() => setRenewPopup(false)}
              >
                ✕
              </button>
            </div>

            <div className="workspace-grid">
              <div className="workspace-field">
                <label>Select Plan</label>

                <select
                  name="show_ads_days"
                  value={renewData.ads_plan_id}
                  onChange={handleRenewChange}
                >
                  <option value="">Select Days</option>

                  {adsPlans.map((plan) => (
                    <option key={plan.id} value={plan.id}>
                      {plan.days} Days - ₹{plan.amount}
                    </option>
                  ))}
                </select>
              </div>

              {/* AMOUNT */}
              <div className="workspace-field">
                <label>Amount Pay</label>

                <input value={renewData.ads_amount} readOnly />
              </div>

              <div className="machine-full-width">
                <button
                  type="button"
                  className="machine-submit-btn"
                  onClick={handleRenewSubmit}
                >
                  {paymentMode === "pending"
                    ? "Pay & Submit Ads"
                    : "Pay & Submit Renewal"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {carouselOpen && carouselImages.length > 0 && (
        <div
          className="lightbox-overlay"
          onClick={() => setCarouselOpen(false)}
        >
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="lightbox-btn lightbox-close"
              onClick={() => setCarouselOpen(false)}
            >
              ×
            </button>

            {carouselImages.length > 1 && (
              <button
                className="lightbox-btn lightbox-prev"
                onClick={prevSlide}
              >
                ❮
              </button>
            )}

            <img
              src={carouselImages[currentImageIndex]}
              className="lightbox-image"
              alt="Preview"
            />

            {carouselImages.length > 1 && (
              <button
                className="lightbox-btn lightbox-next"
                onClick={nextSlide}
              >
                ❯
              </button>
            )}

            <div className="lightbox-counter">
              {currentImageIndex + 1} / {carouselImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
